export default __webpack_public_path__ + "static/media/no-stop-campaign.d97af7f7.svg";